import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'ngx-deficiency-alert-button',
    template: `
        <div class="alert-status-cell" *ngIf="iconLeadLabel" (click)="onLeadIconClick.emit()">
            <span class="leader-text" [ngClass]="status">{{ iconLeadLabel }}</span>
            <nb-icon
                pack="eva"
                [icon]="'alert-triangle-outline'"
                [status]="status"
                *ngIf="iconLeadLabel"
                (click)="onLeadIconClick.emit()"
            ></nb-icon>
        </div>
    `,
    styleUrls: ['./deficiency-alert-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeficiencyAlertButtonComponent {
    /** text label to place ahead of the icon */
    @Input() iconLeadLabel: string;
    @Input() status: string = 'warning';
    @Output() onLeadIconClick?: EventEmitter<any> = new EventEmitter();
}
